// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-271KA","context":"context-1sZfi","info":"info-1gn1P","text":"text-2Pk6N","warning":"warning-14DZE"};